import {
  Sun, Moon, Monitor, ChevronDown, ChevronRight, X, AlertCircle,
  TrendingUp, TrendingDown, Settings, LogOut, RefreshCw, Plus,
} from 'lucide-preact';

export const Icons = {
  Sun, Moon, Monitor, ChevronDown, ChevronRight, X, AlertCircle,
  TrendingUp, TrendingDown, Settings, LogOut, RefreshCw, Plus,
} as const;

export type IconName = keyof typeof Icons;
